import { Component } from '@angular/core';
import { HomeService } from 'src/home/home.service';
import { ListMasterBillingConcept, MasterBillingConcept } from 'src/models/masterBillingConcept.interface';
import { MasterBillingConceptModalComponent } from '../billing-concept-modal/master-billing-concept-modal.component';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { PaginatorService } from 'src/home/paginator.service';
import { BillingService } from '../services/billing.service';

@Component({
  selector: 'app-master-billing-concept',
  templateUrl: './master-billing-concept.component.html',
  styleUrls: ['./master-billing-concept.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }]
})
export class MasterBillingConceptComponent {

  listMasterBillingConcept: ListMasterBillingConcept = {
    pageNumber: 0, //pagina actual
    totalPages: 0, //total de paginas
    currentPageElements: 0, //elementos por pagina
    totalElements: 0, //total de elementos
    results: [{ id: 0, providerId: 0, concept: '', description: '' }]
  };

  copyListMasterBillingConcept: any = [];
  public isLoading: boolean = false;

  constructor(private billingService: BillingService, private dialog: MatDialog) {

  }

  ngOnInit(): void {
    this.handleGetMasterBillingConcept(1)
  }

  openConceptFormModal(): void {
    const dialogRef = this.dialog.open(MasterBillingConceptModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: { title: 'Agregar concepto financiero' }
    });

    dialogRef.afterClosed().subscribe(newConcept => {
      if (newConcept) {
        this.handleCreateMasterBillingConcept(newConcept);
      }
    });
  }



  handleGetMasterBillingConcept(page: number): void {
    this.isLoading = true
    this.billingService.getMasterBillingConcept(page).subscribe((data: ListMasterBillingConcept) => {
      this.isLoading = false;
      this.listMasterBillingConcept = data
    },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Hubo un error al cargar los conceptos de facturación',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
      })
  }

  handlePageEvent($event: PageEvent): void {
    this.listMasterBillingConcept.pageNumber = $event.pageIndex
    this.listMasterBillingConcept.currentPageElements = $event.pageSize;
    this.listMasterBillingConcept.totalElements = $event.length;
    this.handleGetMasterBillingConcept($event.pageIndex + 1);
  }

  noMoreResults(): boolean {
    return this.listMasterBillingConcept.totalElements === this.listMasterBillingConcept.results.length;
  }


  handleCreateMasterBillingConcept(newConcept: MasterBillingConcept): void {
    this.isLoading = true;
    this.billingService.createMasterBillingConcept(newConcept).subscribe(
      () => {
        this.isLoading = false;
        Swal.fire({
          text: '¡Concepto de facturación creado exitosamente!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50'
        });
        this.handleGetMasterBillingConcept(1);
      },
      (error: any) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Hubo un error al crear concepto de facturación',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
      }
    );
  }

}
